import { CfcModel } from "./cfc.model";
import { ExameModel } from "./exame.model";
import { LocalModel } from "./local.model";
import { MarcacaoExameDisponibilidadeModel } from "./marcacao-exame-disponibilidade.model";

export class MarcacaoExameDisponibilidadeBloqueioModel {

  id?: number;
  idLocal?: number;
  idExame?: number;
  idMarcacaoExameDisponibilidade?: number;
  idCfc?: number;
  diaSemana?: string;
  turno?: string;
  dataInicio?: any;
  dataFim?: any;
  observacao?: string;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  ativo?: boolean;
  exame?: ExameModel;
  local?: LocalModel;
  marcacaoExameDisponibilidade?: MarcacaoExameDisponibilidadeModel;
  cfc?: CfcModel;

  constructor(
    options: MarcacaoExameDisponibilidadeBloqueioModel = {}
  ) {
    this.id = options.id || null;
    this.idLocal = options.idLocal || null;
    this.idExame = options.idExame || null;
    this.idMarcacaoExameDisponibilidade = options.idMarcacaoExameDisponibilidade || null;
    this.idCfc = options.idCfc || null;
    this.diaSemana = options.diaSemana || null;
    this.turno = options.turno || null;
    this.dataInicio = options.dataInicio || null;
    this.dataFim = options.dataFim || null;
    this.observacao = options.observacao || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.ativo = options.ativo || null;
    this.exame = options.exame || null;
    this.local = options.local || null;
    this.marcacaoExameDisponibilidade = options.marcacaoExameDisponibilidade || new MarcacaoExameDisponibilidadeModel();
    this.cfc = options.cfc || new CfcModel();
  }
}

